import React, { Component } from 'react'
import { Form } from '@ant-design/compatible'
import '@ant-design/compatible/assets/index.css'
import 'antd4/lib/grid/style/index.css'

import { Modal, InputNumber } from 'hljd'
import { observer, inject } from 'mobx-react'
import { goPayment } from '@util'
import { EXPERIENCE_SHOP_COOP_MANAGE, PRODUCT_SERVICE_FEE } from '@constant'
import { getMoney } from '@hlj/hlj-utils'
import style from './style.module.less'

const formItemLayout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 }
}

@Form.create()
@inject('pageStore')
@observer
export default class extends Component {
  submit = e => {
    e.preventDefault()
    this.props.form.validateFields((err, values) => {
      if (!err) {
        goPayment({
          title: '服务费账户充值',
          fee: values.price,
          return_url: EXPERIENCE_SHOP_COOP_MANAGE,
          apiName: '/p/wedding/index.php/admin/APIMerchantBrokerage/pay',
          payParams: { input_money: values.price },
          product_id: PRODUCT_SERVICE_FEE
        })
      }
    })
  }

  render() {
    const { getFieldDecorator } = this.props.form
    const { visible, setStoreData } = this.props.store
    const {
      brokerageInfo: { brokerageBalance }
    } = this.props.pageStore

    return (
      <Modal
        title="服务费账户充值"
        visible={visible}
        onOk={this.submit}
        onCancel={() => setStoreData({ visible: false })}
      >
        <Form className={style.form}>
          <Form.Item {...formItemLayout} label="服务费账户余额">
            <div>{getMoney(brokerageBalance)}</div>
          </Form.Item>
          <Form.Item {...formItemLayout} label="充值金额">
            {getFieldDecorator('price', {
              initialValue: '',
              rules: [
                {
                  required: true,
                  message: '请输入充值金额'
                }
              ]
            })(<InputNumber style={{ width: 200 }} placeholder="请输入" />)}
          </Form.Item>
        </Form>
      </Modal>
    )
  }
}
